namespace $ {

	export const $bog_max_owner = {
		uk: 'Управляющая компания',
		ads: 'Аварийно-диспетчерская служба УК',
		rso: 'Ресурсоснабжающая организация',
		municipal: 'Муниципальная служба',
		police: 'Участковый уполномоченный полиции',
	} as const

	export const $bog_max_scope = {
		house: 'В доме',
		yard: 'Во дворе',
		city: 'В районе',
		other: 'Другое место',
	} as const

}
